import React, {
    useEffect,
    useRef
} from 'react';

import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import iconRetina from 'leaflet/dist/images/marker-icon-2x.png';

type PropsType = {
    lat?: number | null;
    lng?: number | null;
};

const DefaultIcon = L.icon({
    iconUrl: icon,
    iconRetinaUrl: iconRetina,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;

const Map: React.FC<PropsType> = ({ lat, lng }) => {
    const mapContainerRef = useRef<HTMLDivElement>(null);
    const mapRef = useRef<L.Map | null>(null);

    useEffect(() => {
        if (!mapContainerRef.current || mapRef.current) {
            return undefined;
        }

        const hasPoint = Boolean(lat && lng);
        const map = L.map(mapContainerRef.current, {
            zoomControl: false,
            attributionControl: false,
            scrollWheelZoom: false,
            doubleClickZoom: hasPoint,
            dragging: hasPoint,
            touchZoom: hasPoint,
            boxZoom: hasPoint,
            keyboard: hasPoint
        }).setView(
            hasPoint ? [lat as number, lng as number] : [62.0, 15.0],
            hasPoint ? 13 : 4.5
        );

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: ' ',
            maxZoom: 19
        }).addTo(map);

        if (hasPoint) {
            L.marker([lat as number, lng as number], { interactive: false }).addTo(map);
        }

        mapRef.current = map;
            const timeoutId = window.setTimeout(() => {
            map.invalidateSize();
        }, 300);

        return () => {
            window.clearTimeout(timeoutId);
            map.remove();
            mapRef.current = null;
        };
    }, [lat, lng]);

    return (
        <div
            ref={mapContainerRef}
            style={{
                width: '100%',
                height: '100%',
                minHeight: 360
            }}
        />
    );
};

export default Map;
